<template>
    <div class="imageSlider__sliderContainer" v-cloak>
        <Splide class="imageSlider__slider" :options="options">
            <SplideSlide class="imageSlider__slide slide"
                         v-for="(slide, i) in slides"
                         :key="i"
            >
                <img v-if="slide.img"
                     :src="slide.img"
                     :alt="slide.alt"
                     height="796"
                     width="1500"
                     draggable="false"
                     loading="lazy"
                     class="imageSlider__img"
                />
            </SplideSlide>
        </Splide>
    </div> <!-- .sliderWrap -->
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import { defineComponent, defineProps } from 'vue'
import CaseStudyCard from './case_study_card.vue';

export default defineComponent({
    props: {
        slides: {
            type: Object,
        },
        options: {
            type: Object,
        }
    },
    components: {
        Splide,
        SplideSlide,
        CaseStudyCard
    },
    mounted() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 250);
    }
});
</script>
